import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { IKeyDown } from '../Interfaces';
import { DrawingsHolderService } from '../drawings-holder.service';

@Injectable()
export class DeleteObjectComponent extends ComponentBase implements IKeyDown {

  selectedObject: any;

  constructor(
    private drawings: DrawingsHolderService
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(obj => {
      this.selectedObject = obj;
    });
  }

  keyDown(e: KeyboardEvent): boolean {
    const isDelelte = e.keyCode === 46;
    const isBackspace = e.keyCode === 8;
    this.selectedObject.forEach(obj => {
      if (obj && (isDelelte || isBackspace)) {
        this.drawings.canvas.remove(obj);
      }
    });
    if (isDelelte || isBackspace) {
      this.drawings.onSelect.next([]);
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DeleteObjectComponent.ts